import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Users, Crown, Gift, TrendingUp, Award, ChevronDown, ChevronUp } from "lucide-react";

const STAT_CARDS = [
  { key: "total_users", label: "Total Users", icon: Users, iconColor: "text-blue-500", bg: "bg-blue-500/10", statKey: "total_users",
    detail: (stats) => (<><p>All registered users on the platform, including free and premium tiers.</p><p className="mt-2 text-xs">Click user table below to see full list.</p></>) },
  { key: "founders", label: "Founders", icon: Award, iconColor: "text-amber-500", bg: "bg-amber-500/10", statKey: "founders",
    detail: (stats) => (<><p>First 100 users who signed up. They receive 25% off all plans and a legacy badge.</p><p className="mt-2 text-xs">{100 - (stats?.founders || 0)} founding spots remaining.</p></>) },
  { key: "lifetime", label: "Lifetime", icon: Gift, iconColor: "text-emerald-500", bg: "bg-emerald-500/10", statKey: "lifetime_members",
    detail: () => (<><p>Users with lifetime access, including paid and scholarship recipients.</p><p className="mt-2 text-xs">Includes users granted access via admin panel.</p></>) },
  { key: "beta", label: "Beta Users", icon: Crown, iconColor: "text-green-500", bg: "bg-green-500/10", statKey: "beta_users",
    detail: () => (<><p>Users with beta code or admin-granted beta access (3-month free trial).</p><p className="mt-2 text-xs">Code: AUTHENTICNOW (7 uses max)</p></>) },
  { key: "premium", label: "Premium", icon: Crown, iconColor: "text-pink-500", bg: "bg-pink-500/10", statKey: "premium_users",
    detail: (stats) => (<><p>All active premium subscriptions (including trials).</p><p className="mt-2 text-xs">Monthly: {stats?.monthly_subscribers || 0} | Annual: {stats?.yearly_subscribers || 0}</p></>) },
  { key: "paid_founders", label: "Paid Founders", icon: Award, iconColor: "text-yellow-600", bg: "bg-yellow-500/10", statKey: "paid_founders",
    detail: () => (<><p>Subscribers who locked in the 25% Founder discount (first 100).</p><p className="mt-2 text-xs">Forever members of the Founders' Circle!</p></>) },
  { key: "trials", label: "Active Trials", icon: TrendingUp, iconColor: "text-teal-500", bg: "bg-teal-500/10", statKey: "active_trials",
    detail: (stats) => (<><p>Users currently in their 3-day free trial period.</p><p className="mt-2 text-xs">Converted: {stats?.converted_trials || 0} | Cancelled: {stats?.cancelled_trials || 0}</p></>) },
  { key: "coupons", label: "Coupons Used", icon: Gift, iconColor: "text-orange-500", bg: "bg-orange-500/10", statKey: "coupon_redemptions",
    detail: () => (<><p>Total coupon codes redeemed (COMPASSION, SCHOLARSHIP1-5).</p><p className="mt-2 text-xs">Scholarships: 5 available | COMPASSION: unlimited</p></>) },
];

export const AdminStatsGrid = ({ stats }) => {
  const [expanded, setExpanded] = useState({});
  const toggle = (key) => setExpanded(prev => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-testid="admin-stats-grid">
      {STAT_CARDS.map(({ key, label, icon: Icon, iconColor, bg, statKey, detail }) => (
        <Card
          key={key}
          className="glass-card rounded-2xl border-0 cursor-pointer hover:scale-[1.02] transition-transform"
          onClick={() => toggle(key)}
        >
          <CardContent className="p-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-xl ${bg} flex items-center justify-center`}>
                  <Icon className={`w-5 h-5 ${iconColor}`} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-foreground">{stats?.[statKey] || 0}</p>
                  <p className="text-xs text-muted-foreground">{label}</p>
                </div>
              </div>
              {expanded[key] ? <ChevronUp className="w-4 h-4 text-muted-foreground" /> : <ChevronDown className="w-4 h-4 text-muted-foreground" />}
            </div>
            {expanded[key] && (
              <div className="mt-4 pt-4 border-t border-border/50 text-sm text-muted-foreground">
                {detail(stats)}
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
